import { getMRWebPage } from 'commons/service/bank/mr'
import { MRWebPagePayload, ReportMonthlyWebPage } from 'commons/types/DTO/bank/reportWebPage'
import { Keys, ReadHook, useStateManager } from 'state-manager'

const getHandler = (payload?: MRWebPagePayload) => (): Promise<ReportMonthlyWebPage> => getMRWebPage(payload)

export const useGetMRWebPage: ReadHook<ReportMonthlyWebPage, MRWebPagePayload> = (opts) =>
  useStateManager().use(Keys.MR.Details(opts), getHandler(opts))
